import { gate } from 'hub-http/gates';
export const CHECKOUT_INTERSTITIAL_UI_GATE = gate('SSB:CheckoutInterstitialUI');

// v3 gates - https://product.hubteam.com/docs/gating/next-gen/usage.html#frontend-usage

export const UNIFIED_CART_EXPERIMENT_GATE = gate('Checkout::UnifiedCartExperiment');
export const TRIAL_PURCHASE_MOTION_CTA = gate('MTV:TrialPurchaseMotionCTA');
export const RECOMMENDED_VIEW = gate('SSM:RecommendedView');
export const FTS_STAGED_USERS = gate('FTS:StagedUsers');